import { gql } from '@apollo/client';

export const StartEnableCurrentUserTFAMutation = gql`
    mutation startEnableCurrentUserTFA($currentPassword: String!) {
        startEnableCurrentUserTFA(currentPassword: $currentPassword) {
            secret
            qrCodeUrl
        }
    }
`;
